module.exports = {"id":"187084","name":"Mame Diouf","rating":"77","photo":"./data/images/photos/4/187084.png","club":{"name":"Stoke City","logo":"./data/images/clubs/StokeCity.png"},"positions":["BU","DLD","MD"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MameDiouf0.json
// module id = 2670
// module chunks = 0